import { EEntity } from '@/services/dynamics/enums/entity.enum';

export const showRelateToEntityText = (entityType: EEntity): string => {
  if (!entityType) {
    return 'No entity';
  }

  if (entityType === EEntity.CASE) {
    return 'Case';
  }

  if (entityType === EEntity.ORDER) {
    return 'Order';
  }

  if (entityType === EEntity.ACCOUNT) {
    return 'Account';
  }

  if (entityType === EEntity.CONTACT) {
    return 'Contact';
  }

  if (entityType === EEntity.OPPORTUNITY) {
    return 'Opportunity';
  }

  if (entityType === EEntity.LEAD) {
    return 'Lead';
  }

  return entityType[0]?.toUpperCase() + entityType.slice(1);
};
